export enum Gender {
  MASCULINO = 1,
  FEMENINO = 2,
  NOBINARIO = 3,
}

export interface ISignUpDatosIniciales {
  email: string;
  documentNumber: string;
  procedureNumber: number;
  gender: Gender;
  googleToken: string;
}
